import { render, staticRenderFns } from "./cDocumentActivities.vue?vue&type=template&id=50cbb61b&scoped=true"
import script from "./cDocumentActivities.vue?vue&type=script&lang=js"
export * from "./cDocumentActivities.vue?vue&type=script&lang=js"
import style0 from "./cDocumentActivities.vue?vue&type=style&index=0&id=50cbb61b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cbb61b",
  null
  
)

export default component.exports